export default function getDefaultCalendarThemeOptions () {
    return {
      dataLabels: {
        dropShadow: {
          enabled: false,
        },
      },
        labels: [
            'Google',
            'Apple',
            'Outlook.com (Web)',
            'Outlook',
            'Outlook-new',
            'Microsoft 365',
            'ICS',
            'Other',
        ],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: '100%',
                    },
                    legend: {
                        position: 'left',
                    },
                },
            },
        ],
        colors: [
            '#90CA68',
            '#EE7624',
            '#00A7E0',
            '#EF7624',
            '#F50057',
            '#FEC260',
            '#75BD43',
            '#00A7E0',
        ],
        states: {
          normal: {
              filter: {
                  type: 'none',
                  value: 0,
              },
          },
          hover: {
              filter: {
                  type: 'lighten',
                  value: -0.2,
              },
          },
          active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                  type: 'lighten',
                  value: -0.4,
              },
          },
        },
    };
};
